<!-- @format -->
<ng-container *transloco="let t">
  <div class="calendar-view-container container-fluid">
    <div class="row">
      <div class="col-12 col-md-8 col-xl-9 calendar-content-area">
        <app-full-calendar (toggleRightBar)="toggleRightPanel()"></app-full-calendar>
      </div>
      <div class="col-10 col-sm-6 col-md-4 col-xl-3 calendar-right-bar" [ngClass]="{ closed: !isRightPanelOpen() }">
        <div class="calendar-right-bar-header">
          <sis-tab-navigation [type]="'wide'" [tabs]="tabs"></sis-tab-navigation>
          <button
            type="button"
            (click)="toggleRightPanel()"
            class="non-button collapsible-column-dismiss"
            aria-label="{{ t('ARIA_LABEL.CLOSE') }}">
            <sis-icon icon="close" color="white"></sis-icon>
          </button>
        </div>
        <div ui-view class="calendar-right-bar-content"></div>
      </div>
    </div>
  </div>
</ng-container>
